import type { ComputedRef } from 'vue';
import type { LicenseWarning } from '#layers/license/utils/decide-license-warning';
import { computed } from 'vue';
import { useServerNow } from '#layers/base/public';
import { useSystemLicenseStore } from '#layers/license/stores/license';
import { decideLicenseWarning } from '#layers/license/utils/decide-license-warning';

/**
 * Single reactive source for the license-expiry warning shared by the
 * instance-wide toast and the license settings banner. The decision itself
 * lives in the pure `decideLicenseWarning`; this composable only wires it to
 * the `licenseStore` and the current time.
 *
 * Expiry is instance-wide (its fields are systemInfo-derived and workspace-independent), so it reads
 * the system-pinned store — this also keeps the org license panel from touching the workspace scope.
 */
export function useLicenseExpiryWarning(): ComputedRef<LicenseWarning | null> {
	const license = useSystemLicenseStore();
	const now = useServerNow();

	return computed(() => decideLicenseWarning({
		status: license.status,
		expiresAt: license.expiresAt,
		renewsAt: license.renewsAt,
		gracePeriod: license.gracePeriod,
		now: now.value,
	}));
}
